export default __webpack_public_path__ + "static/media/foreign-round-image.d41a7665.png";